import { Token } from '@lumino/coreutils';
/**
 * The INotebookTree token.
 */
export const INotebookTree = new Token('@jupyter-notebook/tree:INotebookTree');
